import { useSupabaseLoader } from "../../../../../../server/supabase/hooks";
import { SupabaseDigitalAssetService } from "../../../../../assets/server/digital-asset-service";
import { SupabaseMomentService } from "../../../../../moment/server/supabase-moment-service";
import { SupabaseMomentFormSurveyService } from "../../../../../survey/server/supabase-survey-service";
import { getSurveyIdFromUrl } from "../../../components/utils/survey-url";

import type { LinkTarget } from "../../../nodes/link-target-state";

// The name of the Content Library file, email communication or survey a link points to, or
// null for a plain URL.
export const useLinkTitle = (
  url: string,
  target: LinkTarget | undefined,
): { title: string | null; loading: boolean } => {
  const { data: title, loading } = useSupabaseLoader(
    async ({ supabase }) => {
      if (target?.type === "link_lib") {
        const { data } = await new SupabaseDigitalAssetService(supabase).get(target.id);
        return data?.title ?? null;
      }

      if (target?.type === "link_email") {
        const { data } = await new SupabaseMomentService(supabase).get(target.id);
        return data?.title ?? null;
      }

      const surveyId = getSurveyIdFromUrl(url);
      if (surveyId) {
        const { data } = await new SupabaseMomentFormSurveyService(supabase).get(surveyId);
        return data?.title ?? null;
      }

      return null;
    },
    [url, target?.type, target?.id],
  );

  return { title, loading };
};
